import { http } from '@/utils/request'
import FirebasetokenManager from '@/utils/firebasetokenManager'
import type { PageParam } from '@/types/api'
import { getDeviceFingerprint } from '@/utils/pub-use'

export interface TypeVO {
  nickName?: string
  password: string
  invitation?: string
  rememberMe?: boolean
  eamil?: string
}
interface QueryParam {
  roomId?: any
  recordId?: any
  recordInfoId?: any
}
// 推送
export const pushMessage = params => http.post('/center/firebase/refresh/token', params)

// 类型。。。。。。。。
// 查询列表
export const getTypePage = (params: PageParam) => http.get('/admin/type/page', params)

// 查询所有列表
export const getAllType = () => http.get('/admin/type/get/tree')

// 查询详情
export const getType = (id: number) => http.get('/admin/type/get', { id })

// 新增
export const createType = (data: TypeVO) => http.post('/admin/type/create', data)

// 修改
export const updateType = (data: TypeVO) => http.put('/admin/type/update', data)

// 删除
export const deleteType = (id: number) => http.delete(`/admin/type/delete/${id}`)

// 游戏。。。。。。。
// 查询所有列表
export const getAllGame = () => http.get('/game/game/total')

export const gethistoryPage = (params: PageParam) => http.get('/game/round/history', params)

export const getpersonPage = (params: PageParam) => http.get('/game/bet/person', params)

export const getcurrentPage = (params: PageParam) => http.get('/game/bet/current', params)

export const betinfo = (params: QueryParam) => http.get('/game/bet/info', params)

export const login = (data: TypeVO) => http.post('/center/email/login', data)

export const register = (data: TypeVO) => http.post('/center/email/register', data)

// 重发邮件
export const reSend = params => http.get('/center/email/reSend', params)

export const verification = (token: any) => http.get(`/center/email/verification/${token}`)

// API 响应基础类型
export interface ApiResponse<T = any> {
  code: number
  data: T
  msg?: string
}

// 用户信息类型
export interface UserInfo {
  userId: number
  accessToken: string
  refreshToken: string
  expiresTime: number
  siteMsg: any
  userWalletInfos?: Array<{
    availableAccount: string
  }>
}

// 登录表单类型
export interface LoginForm {
  phone: string
  password: string
  areaCode: string
  platform: number
  deviceNumber?: string // 添加设备指纹字段
  channelId?: string // 添加渠道ID字段
}

// 注册表单类型
export interface RegisterForm {
  phone: string
  password: string
  areaCode: string
  platform: number
  deviceNumber?: string // 添加设备指纹字段
  channelId?: string // 添加渠道ID字段
}

export async function info(): Promise<ApiResponse<UserInfo>> {
  const rs = await http.get('/center/email/info')
  try {
    if (rs.data) {
      if (FirebasetokenManager.getUpdateToken()) {
        const token = FirebasetokenManager.getToken()
        const projectId = FirebasetokenManager.getFirebaseProjectId()
        let params = {
          token: token,
          projectId: projectId
        }
        await pushMessage(params).then(() => {
          FirebasetokenManager.setUpdateToken(false)
        })
      }
    }
  }
  catch {
    // 忽略错误
  }
  return rs
}

// 头像修改
export const updateAvatar = id => http.put('/center/user/updateAvatar?id=' + id)

// 密码修改
export const changePassword = data => http.post('/center/user/changePassword', data)

// 玩家币种
export const currencygetAll = () => http.get('/center/user-currency/getAll')

// 玩家新币种
export const currencyinfo = () => http.get('/center/user/info')

// 邮箱密码修改
export const emailchangePassword = data => http.post('/center/email/changePassword', data)

export const notoken = data => http.post('/center/email/reset/noToken', data)

// 玩家弹窗Info信息（已废弃）
export const personalData = () => http.get('/game/player/personalData')

export const playerinfo = (params: PageParam) => http.get('/game/player/info', params)

// 热门
export const populargame = () => http.get('/game/game/popular')

// 最近
// export const recentgame = () => {
//   return request.get({ url: '/game/game/recent' })
// }

// 原创
export const originalgame = () => http.get('/game/game/original')

// 最新
export const nowgame = () => http.get('/game/game/now')

export const recommendgame = params => http.get('/game/game/recommend', params)

// 头像
export const avatargetAll = () => http.get('/center/user-avatar/getAll')

export const putupdateAvatar = (path: any) => http.put('/center/user/updateAvatar', { path })

// 投注
export const betcreate = data => http.post('/game/bet/create', data)

export const singleBetting = data => http.post('/game/bet/singleBetting', data)

export const roomcontract = () => http.get('/game/room/contract')

export const commoninfo = () => http.get('/center/common/info')

export const contractgetInfo = () => http.get('/game/bet/contract/getInfo')

export const gameRule = roomid => http.get(`/game/game/gameRule/${roomid}`)

// 投注历史
export const bettingHistory = async params => await http.get('/game/player/bettingHistory', params)

//  获得所有一级游戏类型
export const first = data => http.get('/game/game/get/first', data)

// 游戏统计
export const statistics = params => http.get('/game/player/gameStatistics', params)

// 游戏推荐title
export const recommendation = (data?: any) => http.get('/platform/vendor-game/getRecommendType', data)

// 游戏推荐title数据
export const recommendationdata = params => http.get('/platform/vendor-game/getRecommendTypeGame', params)

// 获取最近游戏数据
export const zuigetRecentGames = params => http.get('/platform/vendor-game/getRecentGames', params)

// 创建银行账户信息
export const createbankInformation = data => http.post('/center/user-bank-accounts/create', data)

// 刪除银行账户信息
export const deletebankInformation = id => http.delete('/center/user-bank-accounts/delete', { id })

// 获得银行账户信息
export const obtainedbankInformation = id => http.get('/center/user-bank-accounts/get', { id })

// 获得全部银行账户信息
export const obtainedbankallInformation = data => http.get('/center/user-bank-accounts/getAll', data)

// 更新银行账户信息
export const updateInformation = data => http.put('/center/user-bank-accounts/update', data)

// 設置默認银行卡
export const deflketInformation = id => http.put('/center/user-bank-accounts/setDefault', { id })

// 用户注册接口
export const userreg = (data: RegisterForm): Promise<ApiResponse<UserInfo>> =>http.post('/center/phone/register', data)
// 用户登录接口
export const userlogin = (data: LoginForm): Promise<ApiResponse<UserInfo>> =>http.post('/center/phone/login', data)
// 用户绑定邮箱
export const captcha = params => http.get('/center/email/captcha', params)

// 第三方游戲類型
export const thirdPartyGame = params => http.get('/platform/vendor-game/page', params)

// 第三方游戲進入
export const thirdPartygoGame = data => http.post('/platform/vendor-game/intoGame', data)

// 获得所有游戏厂商
export const thirdPartygetGameVendors = (params?: any) => http.get('/platform/game-vendor/getVendors', params)

// 获得热门游戏分页
export const hotPage = params => http.get('/platform/vendor-game/hotPage', params)

// 兌換禮包碼
export const code = params => http.post('/center/gift/redeem?code=' + params.code)

// 获取充值档位
export const rechargegetall = (data?: any) => http.get('/center/purchase/getAll', data)

// 获取充值渠道
export const channellist = (params?: any) => http.get('/center/payment/getPaymentType', params)
// 获取提现渠道
export const withdrawgetall = (params?: any) => http.get('/center/payment/getWithdrawType', params)
// 發起充值
export const gorecharge = data => http.post('/center/payment/charge', data)
// 获取提现银行名称
export const withdrawbankname = (params?: any) => http.get('/center/bank-name/getAll', params)
// 获取提现方式列表
export const getWithdrawTypeList = (params?: any) => http.get('/center/user-withdraw/appGetAll', params)
// 發起提現
export const withdraw = data => http.post('/center/payment/withdraw', data)

// 充值记录分页
export const userRecharge = params => http.get('/center/user-recharge/getRecord', params)

// 获得退款记录
export const chargebackRecord = params => http.get('/center/user-withdraw/getRecord', params)

// 收藏
export const collect = params => http.put('/platform/vendor-game/collect?gameId=' + params.gameId)

// 取消收藏
export const uncollect = params => http.delete('/platform/vendor-game/cancelCollect?gameId=' + params.gameId)

// 收藏列表
export const collectList = (params?: any) => http.get('/platform/vendor-game/collectPage', params)

// 获取首页栏目列表
export const getHomeColumnList = () => http.get('/platform/column/getAll')

// 获取账户流水
export const accountFlow = params => http.get('/center/bill/getAccountStream', params)

// 获取投注记录
export const bettingFlow = params => http.get('/center/bill/getBetRecord', params)

// 获取投注记录
export const bettingStatistics = params => http.get('/center/bill/gameStatist', params)

// 获取轮播图接口
export const carouselChart = () => http.getBannerCached()

// 获取活动列表
export const activityList = () => http.get('/center/activity/getActivity')

// 获取VIP
export const gameVIP = () => http.get('/center/vip/getUserVip')

// 获取站内信列表
export const siteMsglist = data => http.post('/center/siteMsg/msg', data)

// 标记站内信已读未读
export const siteMsglistread = data => http.post('/center/siteMsg/read', data)

// 获取用户推广信息
export const userpromoterInfo = () => http.get('/center/user-promoter/promoterInfo')

// 领取宝箱奖励
export const drawBoxReward = id => http.get(`/center/user-promoter/drawBoxReward/${id}`)

// 获取排行榜1新0旧
export const getRankingList = type => http.get(`/center/user-promoter/getRank/${type}`)

// 获取用户头像
export const getUserAvatar = () => http.get('/center/user-avatar/getAll')

// 修改用户头像 - 直接在URL中拼接ID
export const updateUserAvatar = (id: number) => http.put(`/center/user/updateAvatar?id=${id}`, null)

// 获取官网Apk
export const getOfficialApk = () => http.get('/center/promotion-app/getOfficialApk')

// 檢查排行榜是否開啓
export const checkRank = () => http.get('/center/user-promoter/checkRankOpen')

export const batchGetGames = () => http.get('/platform/vendor-game/home')

export const batchGetGamesPopup = () => http.get('/platform/banner/getAllPopup')

// 获取列表弹窗
export const getAllListPopup = () => http.get('/center/list-popup/getAll')

// 获取弹窗优先级
export const getPopupPriority = () => http.get('/center/list-popup/getPopupPriority')
export const getAllBanners = () => http.get('/platform/banner/getAll')
//新厂商列表
export const ListaDEFabricantes = (params?: { gameType?: string | null }) => http.getVendorsCached(params)
//获取厂商游戏信息
export const getVendorGameInfo = (params: any) => http.get('/platform/vendor-game/getVendorGameInfo', params)
export const claimCommission = () => http.get('/center/user-promoter/claimCommission')
export const getPromoterRecordPage = (params: any) => http.get('/center/user-promoter/getCommissionReward', params)
export const CountdownToMine = () => http.get('/center/mysterious-mine/getMysteriousMine')
//获取游戏信息
export const getGame = (data: number[]) => http.post('/platform/vendor-game/getGameById', data)
//挖矿领奖
export const CountdownreceiveTheAward = () => http.get('/center/mysterious-mine/claimReward')
//助力金
export const financialInformation = () => http.get('/center/help-get-cash/getHelpGetCash')
//领取助力金
export const receiveTheAward = () => http.get('/center/help-get-cash/raffle')
//获得返水活动
export const getUserAntiWater = () => http.get('/center/anti-water/getUserAntiWater')
//获得宝箱配置
// 获取宝箱配置
export const getPromoterBox = (params) => http.get('/center/user-promoter/getPromoterBox', params)
// 获取首页配置管理
export const getRightLst = () => http.get('/center/home-market/get')
//返水领奖
export const receivePrize = () => http.get('/center/anti-water/receivePrize')
//获得厂商返水
export const getVendorAntiWater = (params) => http.get('/center/anti-water/getVendorAntiWater', params)
//获得厂商返水历史
export const getVendorAntiWaterHistory = (params) => http.get('/center/anti-water/getVendorList', params)
//获得VIP配置数据
export const getUserVipInfo = () => http.get('/center/vip-data/getUserVipInfo')
//领取VIP全部奖励
export const drawReward = (params) => http.get('/center/vip-data/drawReward', params)
//站内信一键已读
export const readAll = () => http.put('/center/siteMsg/readAll')
//推广员设置数据
export const getPromoterConfig = () => http.get('/center/user-promoter/getPromoterConfig')
export const getUserContribution = (params) => http.get('/center/user-promoter/getUserContribution', params)
export const rewardData = (params) => http.get('/center/user-reward-data/page', params)
//登出
export const logout = () => http.get('/center/user/logout')
//获取救援金信息
export const getUserRescue = (id) => http.get(`/center/rescue-fund/getUserRescueFund?id=${id}`)
//领取救援金
export const receiveRescue = (id) => http.get(`/center/rescue-fund/claimed?id=${id}`)
//验证用户登录密码
export const checkUserPassword = (password) => http.get(`/center/user/checkUserPassword?password=` + password)
//重置密码
export const resetPassword = (password) => http.put(`/center/user/updatePassword?password=` + password)
//绑定邮箱
export const bindEmailReward = (reward) => http.put(`/center/user/bindEmail?email=` + reward)
//提现密码
export const setWithdrawPassword = (reward) => http.put(`/center/user/setWithdrawPassword?password=` + reward)
export const visitApp = (params) => http.get(`/center/promotion-app/visit-app`, params)
//稽核管理
export const auditRecord = (params) => http.get(`/center/user-obfuscation/userAuditPage`, params)
//获得神秘彩金活动
export const getMysteriousGoldActivity = () => http.get('/center/mysterious-bounds/appGetActivity')
//领取神秘彩金活动
export const receiveMysteriousGoldActivity = (day) => http.get(`/center/mysterious-bounds/claimReward/${day}`)
//获得签到接口
export const getActivity = () => http.get(`/center/continuous-sign-in/getActivity`)

//签到
export const signIn = () => http.get(`/center/continuous-sign-in/signIn`)
//获取首冲弹窗
export const getPopup = () => http.get(`/center/user-first-recharge-data/getPopup`)
//领奖
export const drawRewards = () => http.get(`/center/user-first-recharge-data/drawReward`)
//获取首提现弹窗
export const getPopupwithdraw = () => http.get(`/center/user-first-withdraw-data/getPopup`)
//首提领奖
export const drawRewarddrawRewards = () => http.get(`/center/user-first-withdraw-data/drawReward`)
export const getPromotionAppByName = (params: any) => http.get('/center/promotion-app/getByName', params)
export const getByName = () => http.get('/center/phone/getVerifySwitch')
export const sendVerifyCode = (data) => http.post('/center/phone/sendSms', data)
//验证验证码是否正确
export const getSms = (data) => http.post('/center/phone/getSms', data)
//获取稽核游戏
export const getAudioGames = (param) => http.get('/platform/vendor-game/getAudioGames', param)
//获取稽核厂商类型
export const getAudioVendor = (param) => http.get('/platform/game-vendor/getAudioVendor', param)
//获取新用户专属转盘
export const userTurntable = () => http.get('/center/new-user-exclusive/appGetNewUserExclusive')
//抽奖
export const lottery = () => http.get('/center/new-user-exclusive/lottery')

//放弃奖励
export const giveUp = () => http.get('/center/new-user-exclusive/giveUp')
//新用户首冲
export const getConfig = (params) => http.get('/center/day-recharge/getConfig', params)
//获取站点显示配置
export const getSiteDisplayConfig = () => http.get('/center/site-show-config/appGetAll')
//提现配置
export const  withdrawalConfiguration = () => http.get('/center/user-withdraw/getWithdrawManager')
